export const enClientPortalOrderDetailsPagePages = {
    orders: {
        orderDetailsPage: {
            allOrders: 'All orders',
            title: 'Order overview',
            emptyStateTitle: 'No data found for this order',
            options: 'Options',
            external: 'External',
            save: 'Save',
            notSet: 'Not set yet',
            noPurpose: 'No purpose provided',
            noInformation: 'No information',
            openTasks_one: '{{count}} open task',
            openTasks_other: '{{count}} open tasks',
            assigneeUser: 'User',
            observers: {
                edit: 'Edit observers',
                stopObserving: 'Stop observing order',
                observe: 'Observe order',
                empty: 'No one is currently observing this order.',
                header: {
                    protectedTooltip: 'As an order assignee, you automatically observe this order.',
                    platformUserTooltip: 'Platform users cannot add themselves as observers.',
                    observingTooltip: 'You are observing this order. Click to stop observing.',
                    notObservingTooltip: 'You are not observing this order. Click to observe it.',
                    addObserverTooltip: 'Add observers',
                    observerGroup: 'Observers',
                    disableObservationAriaLabel: 'Disable observing',
                    enableObservationAriaLabel: 'Enable observing',
                },
                drawer: {
                    title: 'Edit observers',
                    addObserversLabel: 'Add more observers...',
                    observeOrder: 'Observe order',
                    observerCount_one: '{{count}} order observer',
                    observerCount_other: '{{count}} order observers',
                    editObservers: 'Edit observers',
                    responsible: 'Assignee',
                    responsibleRemoveTooltip: 'Order assignees cannot be removed as observers.',
                    infoTitle: 'What are observers?',
                    infoText:
                        'Observers receive email updates about all order news enabled in their notification settings. This includes order status changes, available drafts, new messages, and task updates.',
                    notificationSettings: 'To notification settings',
                },
            },
            sections: {
                assignees: 'Assignees',
                externalContacts: 'External contacts',
                orderData: 'Order data',
                report: 'Appraisal',
            },
            mandatorList: {
                addButton: 'Add mandator',
                addModalTitle: 'Add mandator',
                item: {
                    edit: 'Edit',
                    delete: 'Delete',
                    editModalTitle: 'Edit mandator',
                },
                form: {
                    name: 'Name',
                    street: 'Street',
                    houseNumber: 'House number',
                    zip: 'Postal code',
                    city: 'City',
                    country: 'Country',
                },
            },
            contactList: {
                addButton: 'Add contact',
                addModalTitle: 'Add contact',
                item: {
                    edit: 'Edit',
                    delete: 'Delete',
                    editModalTitle: 'Edit contact',
                },
                form: {
                    salutation: 'Salutation',
                    salutationOptions: {
                        mr: 'Mr.',
                        ms: 'Ms.',
                        dr: 'Dr.',
                        mrDr: 'Mr. Dr.',
                        msDr: 'Ms. Dr.',
                        placeholder: 'Select salutation',
                    },
                    name: 'First and last name',
                    role: 'Role',
                    company: 'Company',
                    street: 'Street',
                    houseNumber: 'House number',
                    zip: 'Postal code',
                    city: 'City',
                    email: 'Email',
                    invalidEmail: 'Invalid email',
                    phoneNumber: 'Phone number',
                    invalidPhoneNumber: 'Invalid phone number',
                    note: 'Note / when should this person be contacted?',
                    infoBox: 'All fields are optional. Please only provide personal information needed for contact.',
                },
            },
            customerAssignment: {
                addButton: 'Add customer',
                modalTitle: 'Assigned customers',
                cancel: 'Cancel',
                duplicateWarning: 'The same customer was selected more than once. Please change one of the entries.',
                assigneeLabel: 'Assigned customer',
                removeTooltip: 'Remove',
                addMore: 'Add another',
            },
            assetBox: {
                goToAsset: 'To asset',
                imageAlt: 'Image showing asset',
            },
            contacts: {
                emptyState: 'Add contact details for external participants, for example for the inspection.',
            },
            orderData: {
                costCenter: 'Cost center',
                additionalInformation: 'Additional information',
                valuationReason: 'Order purpose',
                orderDate: 'Order date',
                dueDate: 'Completion date',
                dueDateFallback: 'According to contractual agreement',
                dueDateTooltip:
                    'The completion date is preliminary and may change under certain circumstances. You will be notified about changes by email.',
                valuationDate: 'Valuation date',
                usageType: 'Usage type',
                assetState: 'Asset condition',
                appraiserOffice: 'Appraiser office',
                inspectionDate: 'Inspection date',
                qualityAssessmentDate: 'Quality date',
                reportDate: 'Report date',
            },
            tasks: {
                allTasks: 'All tasks',
                addTaskTooltip: 'Add task',
                createTask: 'Create task',
                status: {
                    open: 'Open',
                    done: 'Completed',
                },
                preview: {
                    showMore: 'Show more',
                    showLess: 'Show less',
                },
                emptyState: 'Create tasks for yourself and others, for example uploading specific documents or coordinating inspections.',
            },
            messages: {
                allThreads: 'All conversations',
                addConversationTooltip: 'Add conversation',
                startConversation: 'Start conversation',
                emptyState: 'Start a conversation to clarify questions, get support, or share information.',
                preview: {
                    showMore: 'Show more',
                    showLess: 'Show less',
                    noTitle: 'No title',
                    noMessagesInThread: 'No messages in this conversation yet',
                    notifiedUsersTooltip: 'No one is currently notified about new messages. Click here to add notified users.',
                    thread: {
                        noMessages: 'No messages',
                        deletedMessage: 'Message was deleted',
                        createdBy: 'Conversation was created by {{userName}}',
                        createdAutomatically: 'The conversation was created automatically',
                    },
                },
            },
            documents: {
                edit: 'Edit documents',
                add: 'Add documents',
                downloadAll: 'Download all',
                emptyText: 'Provide documents for this order. Task documents and message attachments appear here automatically.',
                uploadFiles: 'Upload files',
                modal: {
                    uploadTitle: 'Upload documents',
                    editTitle: 'Edit documents',
                    createButton: 'Create',
                    confirmButton: 'Confirm',
                    cancelButton: 'Cancel',
                    dropzonePrompt: 'Select a file or upload it via drag and drop',
                    nameLabel: 'Name',
                    tagsLabel: 'Tags',
                    unknownMimeTypeLabel: 'Unknown',
                    uploadErrorAlert: {
                        title: 'Error uploading files',
                        description: 'The following files could not be uploaded successfully:',
                        supportText: 'Please try again or send a message to support@einwert.com',
                    },
                },
                table: {
                    nameHeader: 'Name',
                    tagsHeader: 'Tags',
                    dateHeader: 'Date',
                    downloadAction: 'Download document',
                    deleteAction: 'Delete document',
                    deleteModalTitle: 'Delete document',
                    deleteModalPrimaryAction: 'Delete',
                    deleteModalSecondaryAction: 'Cancel',
                    deleteModalDescription: 'Do you really want to delete the document {{documentName}}?',
                },
            },
            images: {
                add: 'Add images',
                downloadAll: 'Download all',
                emptyText: 'Provide images of the asset.',
                upload: 'Upload images',
            },
            valuationSection: {
                noDate: 'No date',
                unknownUser: 'Unknown',
                title: {
                    valueCheck: 'Value check',
                    reportsAndDrafts: 'Appraisals and drafts',
                },
                status: {
                    valueCheckFinalised: 'Your value check has been finalized. You can find the detail view and PDF here.',
                    valueCheckInProgress: 'Your value check is not available yet.',
                    fallbackAppraiser: 'Your appraiser',
                    finalizedReportReady: 'Your finalized appraisal is ready.',
                    approvalReceived: 'has received your approval for finalization and will provide the final appraisal.',
                    annotationsReceived: 'has received your annotations and will provide a new draft.',
                    draftAvailable:
                        'A draft has been provided to you. Check the draft with the plausibility check and add annotations if needed.',
                    draftAvailableWithoutPlausibility: 'A draft has been provided to you.',
                    noReportsPrefix: 'No appraisals or drafts available. Wait until',
                    noReportsSuffix: 'submits a draft or finalized appraisal.',
                },
                card: {
                    reportTitle: 'Appraisal {{date}}',
                    valueCheckTitle: 'Value check {{date}}',
                    final: 'Final',
                    draft: 'Draft {{count}}',
                    submittedAt: 'Submission date',
                    annotationCount_one: '{{count}} annotation',
                    annotationCount_other: '{{count}} annotations',
                    noAnnotations: 'No annotations available',
                    goToPlausibility: 'To plausibility check',
                    goToValueCheck: 'To value check',
                    downloadValueCheck: 'Download value check',
                    goToValuation: 'To valuation',
                    downloadReport: 'Download appraisal',
                    goToDraft: 'To draft page',
                    downloadDraft: 'Download draft',
                },
                handover: {
                    sharedAnnotations: 'Annotations shared',
                    sharedBy: 'Shared by {{userName}}',
                    sharedOn: 'Shared on {{date}}',
                    shared: 'shared',
                    shareAnnotations: 'Share annotations',
                    shareDescription: 'Share annotations with the appraiser and request a new draft.',
                },
                approvals: {
                    approvedDraft: 'Draft approved',
                    approvedBy: 'Approved by',
                    approvedOn: 'Approved on {{date}}',
                    approved: 'approved',
                    approveButton: 'Approve',
                    approveByFund: 'Grant approval by fund partner.',
                    approveDraftAndRequestFinalization: 'Approve the draft and request finalization.',
                    fundSection: 'Approval by fund',
                    kvgSection: 'Approval by CMC',
                },
                modal: {
                    cancel: 'Cancel',
                },
                appraiserSelection: {
                    title: 'No appraiser assigned',
                    description: 'Add at least one appraiser as an observer:',
                    loading: 'Loading appraisers...',
                    empty: 'No linked appraisers are available for this order.',
                    selectLabel: 'Appraiser',
                },
                handoverModal: {
                    title: 'Share annotations',
                    primaryButton: 'Share',
                    imageAlt: 'share',
                    makeAnnotationsVisible: 'Make all annotations on this draft visible to the appraiser',
                    requestNewDraft: 'Request a new draft based on the annotations',
                    infoText: 'You can still add, edit, and delete annotations on this draft. Your appraiser will be notified immediately.',
                },
                approvalModal: {
                    title: 'Approve draft',
                    primaryButton: 'Approve',
                    imageAlt: 'approve',
                    makeAnnotationsVisible: 'Make all annotations on this draft visible to the appraiser',
                    requestFinalizationWithAnnotations:
                        'Request finalization of the appraisal after the annotations have been incorporated',
                    requestFinalization: 'Request finalization of the appraisal',
                    infoText: 'After approval, you can no longer add, edit, or delete annotations on this draft.',
                    confirmationLabel: 'I confirm that I approve the draft for finalization.',
                },
                internalApprovalModal: {
                    title: 'Approve draft',
                    primaryButton: 'Approve',
                    imageAlt: 'approve',
                    fundApproval: 'Grant fund-side approval',
                    confirmationLabel: 'I confirm that I approve this draft.',
                },
                annotationsInfo: 'Your appraiser cannot see your annotations on this draft before you share them.',
            },
            externalAppraiser: {
                addExternal: 'Add external',
                maxOneTooltip: 'Only one external appraiser can be stored.',
                infoTooltip: 'External appraisers without platform access can be included by email.',
                removeAriaLabel: 'Remove {{email}}',
                beta: 'Beta',
                back: 'Back',
                cancel: 'Cancel',
                remove: 'Remove',
                modal: {
                    title: 'Add external appraiser',
                    setup: 'Set up',
                },
                intro: {
                    external: 'External',
                    viaEmail: 'by email',
                    orderEmail: 'Order email',
                    user: 'User',
                    onPlatform: 'on platform',
                    title: 'Collaboration without an appraiser account',
                    description: 'Work on orders with external appraisers across channels without leaving the einwert platform.',
                    orderEmailPrefix: 'Orders receive a',
                    orderEmailHighlight: 'specific order email address.',
                    incomingHighlight: 'Incoming emails',
                    incomingText: 'are automatically imported into conversations and attachments are uploaded.',
                    outgoingHighlight: 'New messages and documents',
                    outgoingText: 'are sent directly from the platform to external contacts through the order email.',
                    missingAsset: {
                        title: 'No asset linked',
                        descriptionBeforeEmail: 'External participants cannot be added to an order without a linked asset. Contact',
                        descriptionAfterEmail: ' to link the asset.',
                    },
                },
                form: {
                    betaTitle: 'Beta feature',
                    betaTextHighlight: 'Only one external appraiser can be stored.',
                    betaText: 'Your messages and documents are therefore sent to only one address.',
                    emailTextHighlight: 'Only emails from the stored address are allowed',
                    emailText: 'and processed automatically when sent to the order email address.',
                    title: 'Store external appraiser',
                    description:
                        'Enter the appraiser details so emails from this address can be processed when sent to the order email address.',
                    organization: 'Company',
                    requiredField: 'Required field',
                    invalidEmail: 'Invalid email',
                    lockedInfo: 'You cannot edit this information after saving.',
                    invitationNotice: {
                        title: 'Invitation is sent immediately',
                        description:
                            'When you create the external appraiser, an invitation with the order email address and data room link is sent to the stored email address.',
                    },
                    salutationOptions: {
                        mr: 'Mr.',
                        ms: 'Ms.',
                        dr: 'Dr.',
                        placeholder: 'Select salutation',
                    },
                },
                delete: {
                    title: 'Remove external appraiser',
                    infoTitle: 'External contact is not notified',
                    infoText: 'The external appraiser will not be notified about this change.',
                    futureEmailsStart: 'Future incoming emails from',
                    futureEmailsEnd: 'will no longer be imported into the order or visible to you.',
                    listImport: 'will no longer be imported into the order',
                    listVisible: 'will no longer be visible to you',
                    irreversible: 'This action cannot be undone.',
                },
            },
        },
    },
}
